// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: hsla(197, 64%, 4%, 1);
  --color-primary-darker: hsl(211, 86%, 0%);
  --color-text: hsl(0, 0%, 4%);
  --color-text-subtle: hsl(0, 0%, 26%);
  --color-text-light: hsl(0, 0%, 100%);
  --color-surface-interactive: hsl(0, 0%, 99%);
  --color-surface-light: hsl(0, 0%, 97%);
  --color-surface: hsl(0, 0%, 93%);
  --color-surface-darker: hsl(0, 0%, 89%);
  --color-glass-card: hsla(0, 0%, 0%, 0.03);
  --color-chart: hsl(0, 0%, 60%);
  --color-border: hsla(0, 0%, 0%, 0.05);
  --color-border-highlight: hsla(0, 0%, 0%, 0.1);
  --color-border-active: hsla(0, 0%, 0%, 0.2);
  --color-destructive: hsl(354, 70%, 54%);
  --color-destructive-darker: hsl(354, 70%, 48%);
  --color-focus: hsl(140, 70%, 96%);
  --color-watched: hsl(320, 70%, 96%);
  --color-dim: hsla(0, 0%, 0%, 0.5);
  --color-dropzone: hsl(211, 100%, 95%);
  --color-dropzone-border: hsl(211, 100%, 50%);
  --nav-height: 72px;
  --gutter: 1rem;
  --radius-full: 999px;
  --radius-card: 0.375rem;
  --radius-default: 0.25rem;
  --radius-small: 0.125rem;
  --golden-ratio: 1.618;
  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  --font-size-base: 0.8125rem;
  --font-size-larger: calc(var(--font-size-base) * 1.125);
  --font-size-smaller: calc(var(--font-size-base) * 0.875);
  --team-member-height: 32px;
  --animation-duration-default: 0.15s;
  --cubic-bezier-default: cubic-bezier(0.4, 0, 0.4, 1);
  --breakpoint-mobile: 768px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: var(--font-size-base);
  line-height: 1.25rem;
  color: var(--color-text);
  background-color: var(--color-surface);
}

.container {
  max-width: 100vw;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: var(--nav-height);
}

h3 {
  font-size: var(--font-size-larger);
}

.card {
  background: var(--color-surface-light);
  border-radius: var(--radius-card);
  padding: var(--gutter);
}
.card__actions {
  display: flex;
  gap: 0.25rem;
}

.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
}
.form-group input, .form-group select, .form-group textarea {
  width: 100%;
}

.grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

.table {
  width: 100%;
  min-width: 800px;
  max-width: none;
  border-collapse: collapse;
  margin-bottom: 1rem;
}
.table th, .table td {
  padding: calc(var(--gutter) / 2);
  border-bottom: 1px solid var(--color-border);
  border-right: 1px solid var(--color-border);
  text-align: left;
}

.td--actions {
  display: flex;
  gap: calc(var(--gutter) / 2);
}

.mb-2 {
  margin-bottom: 1rem;
}

.table-scroll-wrapper {
  flex: 1 1;
  overflow: auto;
  background: var(--color-surface-light);
  padding: 0;
}
.table-scroll-wrapper--inline {
  background: transparent;
  padding: 0;
}

.table-freeze-first-col th:first-child,
.table-freeze-first-col td:first-child {
  position: sticky;
  left: 0;
  background: var(--color-surface-light);
  z-index: 4;
}

.table-freeze-first-col td {
  position: relative;
  height: 160px;
}
.table-freeze-first-col td:hover .info-tooltip-trigger {
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sCAAA;EACA,gCAAA;EACA,uCAAA;EACA,yCAAA;EACA,8BAAA;EACA,qCAAA;EACA,8CAAA;EACA,2CAAA;EACA,uCAAA;EACA,8CAAA;EACA,iCAAA;EACA,mCAAA;EACA,iCAAA;EACA,qCAAA;EACA,4CAAA;EACA,kBAAA;EACA,cAAA;EAEA,oBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EAEA,qBAAA;EAEA,4CAAA;EAEA,2BAAA;EACA,uDAAA;EACA,wDAAA;EAEA,0BAAA;EAEA,mCAAA;EACA,oDAAA;EAEA,0BAAA;AANF;;AAUA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAPF;;AAUA;EACE,uGAAA;EACA,gCAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;AAPF;;AAWA;EACE,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AARF;;AAWA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AARF;;AAWA;EACE,kCAAA;AARF;;AAYA;EACE,sCAAA;EACA,iCAAA;EACA,sBAAA;AATF;AAWE;EACE,aAAA;EACA,YAAA;AATJ;;AAaA;EACE,mBAAA;AAVF;AAYE;EACE,cAAA;EACA,qBAAA;AAVJ;AAaE;EACE,WAAA;AAXJ;;AAgBA;EACE,aAAA;EACA,SAAA;EACA,2DAAA;AAbF;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AAdF;AAgBE;EACE,gCAAA;EACA,4CAAA;EACA,2CAAA;EACA,gBAAA;AAdJ;;AAmBE;EACE,aAAA;EACA,4BAAA;AAhBJ;;AAsBA;EAAQ,mBAAA;AAlBR;;AAqBA;EACE,SAAA;EACA,cAAA;EACA,sCAAA;EACA,UAAA;AAlBF;AAoBE;EACE,uBAAA;EACA,UAAA;AAlBJ;;AAuBA;;EAEE,gBAAA;EACA,OAAA;EACA,sCAAA;EACA,UAAA;AApBF;;AAwBA;EACE,kBAAA;EACA,aAAA;AArBF;AAuBE;EACE,qBAAA;AArBJ","sourcesContent":[":root {\n  --color-primary: hsla(197, 64%, 4%, 1);\n  --color-primary-darker: hsl(211, 86%, 0%);\n  --color-text: hsl(0, 0%, 4%);\n  --color-text-subtle: hsl(0, 0%, 26%);\n  --color-text-light: hsl(0, 0%, 100%);\n  --color-surface-interactive: hsl(0, 0%, 99%);\n  --color-surface-light: hsl(0, 0%, 97%);\n  --color-surface: hsl(0, 0%, 93%);\n  --color-surface-darker: hsl(0, 0%, 89%);\n  --color-glass-card: hsla(0, 0%, 0%, 0.03);\n  --color-chart: hsl(0, 0%, 60%);\n  --color-border: hsla(0, 0%, 0%, 0.05);\n  --color-border-highlight: hsla(0, 0%, 0%, 0.1);\n  --color-border-active: hsla(0, 0%, 0%, 0.2);\n  --color-destructive: hsl(354, 70%, 54%);\n  --color-destructive-darker: hsl(354, 70%, 48%);\n  --color-focus: hsl(140, 70%, 96%);\n  --color-watched: hsl(320, 70%, 96%);\n  --color-dim: hsla(0, 0%, 0%, 0.5);\n  --color-dropzone: hsl(211, 100%, 95%);\n  --color-dropzone-border: hsl(211, 100%, 50%);\n  --nav-height: 72px;\n  --gutter: 1rem;\n\n  --radius-full: 999px;\n  --radius-card: 0.375rem;\n  --radius-default: 0.25rem;\n  --radius-small: 0.125rem;\n\n  --golden-ratio: 1.618;\n\n  --box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n\n  --font-size-base: 0.8125rem;\n  --font-size-larger: calc(var(--font-size-base) * 1.125);\n  --font-size-smaller: calc(var(--font-size-base) * 0.875);\n\n  --team-member-height: 32px;\n\n  --animation-duration-default: 0.15s;\n  --cubic-bezier-default: cubic-bezier(0.4, 0, 0.4, 1);\n\n  --breakpoint-mobile: 768px;\n}\n\n// Reset\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  font-size: var(--font-size-base);\n  line-height: 1.25rem;\n  color: var(--color-text);\n  background-color: var(--color-surface);\n}\n\n// Layout\n.container {\n  max-width: 100vw;\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\nmain {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: var(--nav-height);\n}\n\nh3 {\n  font-size: var(--font-size-larger);\n}\n\n// Components\n.card {\n  background: var(--color-surface-light);\n  border-radius: var(--radius-card);\n  padding: var(--gutter);\n\n  &__actions {\n    display: flex;\n    gap: .25rem;\n  }\n}\n\n.form-group {\n  margin-bottom: 1rem;\n\n  label {\n    display: block;\n    margin-bottom: 0.5rem;\n  }\n\n  input, select, textarea {\n    width: 100%;\n  }\n}\n\n// Grid\n.grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n}\n\n// Tables\n.table {\n  width: 100%;\n  min-width: 800px;\n  max-width: none;\n  border-collapse: collapse;\n  margin-bottom: 1rem;\n\n  th, td {\n    padding: calc(var(--gutter) / 2);\n    border-bottom: 1px solid var(--color-border);\n    border-right: 1px solid var(--color-border);\n    text-align: left;\n  }\n}\n\n.td {\n  &--actions {\n    display: flex;\n    gap: calc(var(--gutter) / 2);\n  }\n}\n\n// Utility\n\n.mb-2 { margin-bottom: 1rem; }\n\n// TableView wrapper\n.table-scroll-wrapper {\n  flex: 1 1 0;\n  overflow: auto;\n  background: var(--color-surface-light);\n  padding: 0;\n\n  &--inline {\n    background: transparent;\n    padding: 0;\n  }\n}\n\n// Freeze first column in TableView\n.table-freeze-first-col th:first-child,\n.table-freeze-first-col td:first-child {\n  position: sticky;\n  left: 0;\n  background: var(--color-surface-light);\n  z-index: 4;\n}\n\n// TableView cell and button hover logic\n.table-freeze-first-col td {\n  position: relative;\n  height: 160px;\n  \n  &:hover .info-tooltip-trigger {\n    opacity: 1 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
